import { CategoryRepository, CategorySortBy } from 'src/app/repositories/category.repository';
import { FunctionsService } from 'src/app/common/services/functions.service';
import { CoreResponseMessage, CoreResponseStatus } from 'src/app/contracts/responseMessage/coreResponseMessage';
import { OrderBy } from 'src/app/repositories/base.repository';
import { User } from '../models/user';
import { Channel } from 'src/app/models/channel';
import { ChannelItem } from 'src/app/models/channel_item';
import { Category } from 'src/app/models/category';
import { ClientConfigService } from 'src/app/common/services/client-config.service';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ChannelItemRepository, ChannelItemSortBy } from '../repositories/channelItem.repository';
import { ChannelRepository } from 'src/app/repositories/channel.repository';
import { Injectable } from "@angular/core";

@Injectable()
export class RssFeedService {
    //categorySortBy: '' | 'Name'

    constructor(private _categoryRepo: CategoryRepository, private _channelItemRepo: ChannelItemRepository, private _channelRepo: ChannelRepository, 
                private _clientConfigService: ClientConfigService, private _http: HttpClient)
    {
    }

    async getCategoriesAllAsync(requestor: User, pageIndex: number, pageSize: number, sortByStr: string, orderByStr: string): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage = await this._categoryRepo.getHeadersAsync(requestor.Email === '' ? environment.defaultEmail : requestor.Email);
        
        if (responseMsg.Status === CoreResponseStatus.OK) {
            let headers = requestor.Email === '' ? responseMsg.Result.set('ExemptValidation', 'true') : responseMsg.Result;
            let sortBy: CategorySortBy = CategorySortBy[sortByStr];
            let orderBy: OrderBy = OrderBy[orderByStr];
            responseMsg = await this._categoryRepo.getAllAsync(headers, pageIndex, pageSize, sortBy, orderBy);               
        }

        // let sortBy: SortBy = SortBy[sortByStr];    
        // let orderBy: OrderBy = OrderBy[orderByStr];
        // responseMsg = await this._categoryRepo.getAllAsync(null, pageIndex, pageSize, sortBy, orderBy);
        // responseMsg.Status = CoreResponseStatus.OK;

        return responseMsg;
    }

    async removeCategoryAsync(requestor: User, category: Category): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;

        if (requestor.Email !== '') {
            responseMsg = await this._categoryRepo.getHeadersAsync(requestor.Email);

            if (responseMsg.Status === CoreResponseStatus.OK) {
                let headers = responseMsg.Result;
                category.Active = false;
                responseMsg = await this._categoryRepo.removeAsync(headers, [category.Id]);
            }
        }

        return responseMsg;
    }

    async updateCategoryAsync(requestor: User, category: Category): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;

        if (requestor.Email !== '') {
            responseMsg = await this._categoryRepo.getHeadersAsync(requestor.Email);

            if (responseMsg.Status === CoreResponseStatus.OK) {
                let headers = responseMsg.Result;
                responseMsg = await this._categoryRepo.updateAsync(headers, category);
            }
        }

        return responseMsg;
    }

    async addCategoryAsync(requestor: User, category: Category) {
        let responseMsg: CoreResponseMessage;

        if (requestor.Email !== '') {
            responseMsg = await this._categoryRepo.getHeadersAsync(requestor.Email);

            if (responseMsg.Status === CoreResponseStatus.OK) {
                let headers = responseMsg.Result;
                category.UserId = requestor.Id;
                category.Active = true;
                responseMsg = await this._categoryRepo.addAsync(headers, [category]);
            }
        }

        return responseMsg;
    }

    async addChannelAsync(requestor: User, channel: Channel): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;

        if (requestor.Email !== '') {
            responseMsg = await this._channelRepo.getHeadersAsync(requestor.Email);

            if (responseMsg.Status === CoreResponseStatus.OK) {
                let headers = responseMsg.Result;
                channel.UserId = requestor.Id;
                channel.Active = true;
                channel.Show = true;
                responseMsg = await this._channelRepo.addAsync(headers, [channel]);
            }
        }

        return responseMsg;
    }

    async updateChannelAsync(requestor: User, channel: Channel): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;

        if (requestor.Email !== '') {
            responseMsg = await this._channelRepo.getHeadersAsync(requestor.Email);

            if (responseMsg.Status === CoreResponseStatus.OK) {
                let headers = responseMsg.Result;
                responseMsg = await this._channelRepo.updateAsync(headers, channel);
            }
        }

        return responseMsg;
    }

    async removeChannelAsync(requestor: User, channel: Channel): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;

        if (requestor.Email !== '') {
            responseMsg = await this._channelRepo.getHeadersAsync(requestor.Email);

            if (responseMsg.Status === CoreResponseStatus.OK) {
                let headers = responseMsg.Result;
                channel.Active = false;
                responseMsg = await this._channelRepo.updateAsync(headers, channel);
            }
        }

        return responseMsg;
    }

    async loadRssItemsAsync(requestor: User, channel: Channel): Promise<CoreResponseMessage> {       
        let responseMsg: CoreResponseMessage;
        
        responseMsg = await this._categoryRepo.getHeadersAsync(requestor.Email === '' ? environment.defaultEmail : requestor.Email);
        
        if (responseMsg.Status === CoreResponseStatus.OK) {
            let headers = responseMsg.Result;
            responseMsg = await this._channelRepo.parseChannelOnServerAsync(headers, channel);
        }

        //responseMsg = await this._channelRepo.parseChannelOnClientAsync(channel);
                    
        return responseMsg;
    }

    async addChannelItemsToFavoriteAsync(requestor: User, channelItems: ChannelItem[]): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;

        if (requestor.Email !== '') {
            responseMsg = await this._channelItemRepo.getHeadersAsync(requestor.Email);

            if (responseMsg.Status === CoreResponseStatus.OK) {
                let headers = responseMsg.Result;
                responseMsg = await this._channelItemRepo.addToFavoriteAsync(headers, channelItems);
            }
        }
        
        return responseMsg;
    }

    async removeChannelItemFromFavoriteAsync(requestor: User, channelItem: ChannelItem): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;

        if (requestor.Email !== '') {
            responseMsg = await this._channelItemRepo.getHeadersAsync(requestor.Email);

            if (responseMsg.Status === CoreResponseStatus.OK) {
                let headers = responseMsg.Result;
                responseMsg = await this._channelItemRepo.removeFromFavoriteAsync(headers, channelItem);
            }
        }

        return responseMsg;
    }

    async getFavoriteItemsAsync(requestor: User, pageIndex: number, pageSize: number, sortByStr: string, orderByStr: string): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;

        if (requestor.Email !== '') {
            responseMsg = await this._channelItemRepo.getHeadersAsync(requestor.Email);

            if (responseMsg.Status === CoreResponseStatus.OK) {
                let headers = responseMsg.Result;
                let sortBy: ChannelItemSortBy = ChannelItemSortBy[sortByStr];
                let orderBy: OrderBy = OrderBy[orderByStr]; 
                responseMsg = await this._channelItemRepo.getFavoriteItems(headers, pageIndex, pageSize, sortBy, orderBy);
            }
        }

        return responseMsg;
    }

    async countFavoriteItemAsync(requestor: User): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;

        if (requestor.Email !== '') {
            responseMsg = await this._channelItemRepo.getHeadersAsync(requestor.Email);

            if (responseMsg.Status === CoreResponseStatus.OK) {
                let headers = responseMsg.Result;
                responseMsg = await this._channelItemRepo.countFavoriteChannelItems(headers);
            }
        }

        return responseMsg;
    }

    async getTodayFeedItemsAsync(pageIndex: number, pageSize: number, sortByStr: string, orderByStr: string): Promise<CoreResponseMessage> {
        let sortBy: ChannelItemSortBy = ChannelItemSortBy[sortByStr];
        let orderBy: OrderBy = OrderBy[orderByStr];

        return await this._channelItemRepo.getTodayFeedItemsAsync(pageIndex, pageSize, sortBy, orderBy);
    }

    async refreshTodayFeedsAsync(): Promise<CoreResponseMessage> {
        let responseMsg = await this._channelItemRepo.getHeadersAsync(environment.defaultEmail);

        if (responseMsg.Status === CoreResponseStatus.OK) {
            let headers = responseMsg.Result;
            responseMsg = await this._channelItemRepo.refreshTodayFeedsAsync(headers);
        }

        return responseMsg;
    }
}